import { render } from "./ImportacaoVeiculo.vue?vue&type=template&id=39205654"
import script from "./ImportacaoVeiculo.vue?vue&type=script&lang=ts"
export * from "./ImportacaoVeiculo.vue?vue&type=script&lang=ts"
script.render = render

export default script